/**
 * Hypothesis - Web & PDF Annotation
 *
 * Exposes broad WAR groups — `client/*`, `help/*` and `pdfjs/*` — to <all_urls> with no
 * `use_dynamic_url`, so its bundled client, help pages and PDF.js viewer assets are all
 * fetchable at fixed URLs from any page.
 *
 * The PDF.js annotation icons are the cleanest signal: vendor-shipped SVGs that load
 * through probeImage with no CORS grant. The client bundle and stylesheet are vendor-named
 * stable paths, not rotating build hashes.
 *
 * Manifest verified against version 1.1754.0.0.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'bjfhmglciegochdpefhhlphglcehbmek';

export const hypothesis: ExtensionDefinition = {
  id: ID,
  name: 'Hypothesis - Web & PDF Annotation',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 200_000,
  notes:
    'client/*, help/* and pdfjs/* exposed to every origin with no dynamic URL. The ' +
    'annotation SVG loads CORS-free and is conclusive.',
  signals: [
    {
      id: 'war-annotation-comment-svg',
      kind: 'web-accessible-resource',
      description:
        'Load pdfjs/web/images/annotation-comment.svg via <img> — a PDF.js annotation ' +
        'icon exposed to every origin, readable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'pdfjs/web/images/annotation-comment.svg'),
    },
    {
      id: 'war-boot-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch client/build/boot.js — the client bootstrap script, a stable vendor path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'client/build/boot.js'),
    },
    {
      id: 'war-annotator-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch client/build/styles/annotator.css — the annotator stylesheet, a third path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'client/build/styles/annotator.css'),
    },
  ],
};
